<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        class='font-weight-light'
        v-model='search'
        append-icon='mdi-magnify'
        label='Search postal code'
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :loading='loading'
      :headers='headers'
      :items='postalCodeList'
      :search='search'
      class='elevation-1'
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-dialog v-if="editDialog" v-model="editDialog" max-width='500px'>
             <template >
              <edit-postalcode :userId='userId' @resetEditDialog='editDialog = $event'
              :postalCode="selectedItem"
              :selectedEditedIndex="editedIndex"></edit-postalcode>
            </template>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action='{ item }'>
        <v-icon text small class='mr-2' @click='editItem(item)'>mdi-border-color</v-icon>
        <v-btn outlined small  @click="jurisdictionList(item)"> View Jurisdiction</v-btn>
      <v-btn  v-if="loadingJurisdictioList && currentToolTipId === item.id" text :loading="loadingJurisdictioList"></v-btn>
        <v-tooltip v-if="currentToolTipId === item.id && !loadingJurisdictioList" v-model="showitemTooltip" right>
      <template v-slot:activator="{ on }">
      <v-icon v-on="on"></v-icon>
      </template>
      <div v-for="(jurisdictionList, index) in jurisdictionPostalCodeList" :key="index">
      <span >{{jurisdictionList.jurisdictionName}}</span>
      </div>
    </v-tooltip>
          </template>
      <template v-slot:no-data>
        <p>{{NO_DATA_FOUND}}</p>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import EditPostalCode from './ManageEditPostalCode'

export default {
  name: 'PostalCodes',
  data: () => ({
    loading: true,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_POSTAL_CODE,
    search: '',
    loadingJurisdictioList: false,
    showitemTooltip: true,
    clearToolTip: false,
    currentToolTipId: null,
    editedIndex: -1,
    selectedItem: {},
    jurisdictionPostalList: [],
    editDialog: false,
    valid: true,
    show: false,
    // table headers
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'Postal Code',
        value: 'postalCode',
        sortable: true,
        class: 'title'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: false,
        class: 'title'
      },
      { text: 'Actions', value: 'action', sortable: false, class: 'title' }
    ]
  }),
  components: {
    'edit-postalcode': EditPostalCode
  },
  computed: {
    // to fetch adoption label list
    postalCodeList () {
      return this.$store.getters['PostalCodeModule/fetchPostalCodeList']
    },
    // to fetch adoption label list
    jurisdictionPostalCodeList () {
      return this.$store.getters['PostalCodeModule/fetchJurisdictionPostalCodeList']
    },
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    // dispatch an action in below method to fetch postal code list
    initialize () {
      // let status = '' // by default status is empty, declare 'status' here for future use
      new Promise((resolve, reject, status) => {
        this.$store.dispatch('PostalCodeModule/getPostalCodeList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          this.loading = false
        })
        .catch(({ response }) => {
          this.loading = false
        })
    },
    editItem (item) {
      this.editedIndex = this.postalCodeList.indexOf(item)
      this.selectedItem = item
      this.editDialog = true
    },
    jurisdictionList (item) {
      this.loadingJurisdictioList = true
      this.currentToolTipId = null
      this.clearToolTip = false
      this.jurisdictionPostalList = this.jurisdictionPostalCodeList
      this.currentToolTipId = item.id
      new Promise((resolve, reject, id = item.id) => {
        this.$store.dispatch('PostalCodeModule/getJurisdictionForPostalCodeItem', {
          resolve,
          reject,
          id
        })
      })
        .then(responseData => {
          this.clearToolTip = true
          this.currentToolTipId = item.id
          this.loadingJurisdictioList = false
        })
        .catch(response => {
          this.loadingJurisdictioList = false
        })
    }
  }
}
</script>
